import { render, staticRenderFns } from "./homeAsideMenuChildren.vue?vue&type=template&id=bca4fd4a&"
import script from "./homeAsideMenuChildren.vue?vue&type=script&lang=js&"
export * from "./homeAsideMenuChildren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/home/menu/default/homeAsideMenuChildren.vue"
export default component.exports